import { Typography, Container } from "@mui/material";
import React from "react";
import getColorsHook from "../../getColorsHook";
import Carousel from "./Carousel";
import classNames from "./style.module.css";

const Banner = () => {
  const [colors] = getColorsHook();
  const styles = {
    banner: {
      background: colors.bgContrast,
      margin: 30,
      padding: 10,
      borderRadius: 6,
    },
    container: {
      display: "flex",
      flexDirection: "column",
      paddingTop: 25,
      justifyContent: "space-around",
    },
  };

  return (
    <div style={styles.banner} className={classNames.banner}>
      <Container style={styles.container}>
        <Carousel />
      </Container>
    </div>
  );
};

export default Banner;
